import { render } from "./TemplateLogin.vue?vue&type=template&id=5ee96804&scoped=true"
import script from "./TemplateLogin.vue?vue&type=script&lang=js"
export * from "./TemplateLogin.vue?vue&type=script&lang=js"

import "./TemplateLogin.vue?vue&type=style&index=0&id=5ee96804&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee96804"]])

export default __exports__